import { SupportedLanguages } from "./localization";

class CovalentClient {
  BASE_URL = "https://external-web-proxy.coinledger.io/api.covalenthq.com";
  
  async getAddressBalance(network, address, quoteCurrency) {
    const url = new URL(`${this.BASE_URL}/${network}/address/${address}/balances_v2/`);
    url.searchParams.set("quote-currency", quoteCurrency);
    const res = await fetch(url);

    const json = await res.json();

    if (json.error) {
      return {
        error: json.error_message,
        error_code: json.error_code
      };
    }

    const asset = json.data?.items.find(i => i.native_token) ?? json.data?.items[0];

    return {
      balance: asset.balance,
      value: asset.pretty_quote,
      last_transfer: asset.last_transferred_at,
      decimals: asset.contract_decimals,
      ticker_symbol: asset.contract_ticker_symbol
    };
  }

  getQuoteCurrencyForLanguage(language) {
    return {
      [SupportedLanguages.English]: "USD",
      [SupportedLanguages.German]: "EUR",
      [SupportedLanguages.Dutch]: "EUR",
      [SupportedLanguages.Swedish]: "SEK"
    }[language] ?? "USD";
  }
}

export default new CovalentClient();